export const SET_CHANGE_REQUEST_TYPE = "SET_CHANGE_REQUEST_TYPE";
